import {
  LIBRARY_GRATUITY_PAGE_REQUEST,
  LIBRARY_GRATUITY_ON_CHANGE_OUTLET_IDS,
  LIBRARY_GRATUITY_GRATUITIES_REQUEST,
  LIBRARY_GRATUITY_ON_CLICK_ROW,
  LIBRARY_GRATUITY_ON_CLICK_CANCEL,
  LIBRARY_GRATUITY_SUBMIT_FORM_CREATE,
  LIBRARY_GRATUITY_ON_CLICK_CREATE_GRATUITY,
  LIBRARY_GRATUITY_DELETE_GRATUITY,
  LIBRARY_GRATUITY_SUBMIT_FORM_UPDATE,
  LIBRARY_GRATUITY_ASK_DELETE_GRATUITY,
  LIBRARY_GRATUITY_CANCEL_DELETE_GRATUITY,
  LIBRARY_GRATUITY_SUBMIT_FORM_CREATE_ALL_OUTLET,
} from 'actions/library/gratuity/constants';
import { takeLatest, put, call, takeEvery, select } from 'redux-saga/effects';
import { initialize, change } from 'redux-form';
import * as act from 'actions';
import * as actNotif from 'actions/notifications';
import * as actGratuity from 'actions/library/gratuity';
import * as apiOutlets from 'api/outlets';
import * as apiProfile from 'api/profile';
import * as apiGratuity from 'api/gratuities';
import { setSelectedOutletIds } from 'actions/actionBar';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import * as clevertapLibraryGratuity from 'clevertap/library/gratuity';
import * as _ from 'lodash';
import { getSelectedOutlet } from 'utils/userProperties';
import * as actOutletList from 'actions/outletPages/list';

const getCloneNotification = state =>
  state.outletPages.list.showCloneOutletNotification.notification;

function* getCloneOutletNotification() {
  const notification = yield select(getCloneNotification);
  return notification;
}

function* fillSearchFormFromProfile(profile) {
  let assignedOutletIds = [];

  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]];
  } else {
    assignedOutletIds = profile.outlet_id;
  }
  const data = { outletIds: assignedOutletIds };
  yield put(initialize('search', data));
}

function* fillForm(gratuity) {
  const form = {
    id: gratuity.id,
    name: gratuity.name,
    amount: gratuity.amount ? gratuity.amount.toString() : gratuity.amount,
  };
  yield put(initialize('gratuity', form));
}

function* openRightColumn() {
  yield put(actGratuity.openRightColumn());
}

function* closeRightColumn() {
  yield put(actGratuity.closeRightColumn());
}

export function* pageRequest() {
  // reset...
  yield put(actGratuity.setGratuities([]));
  yield put(showPageLoadingSpinner(true));
  yield put(actGratuity.setGratuityDetail(null));
  yield put(actGratuity.setOutlets([]));
  yield call(closeRightColumn);

  yield put(act.showProgressBar());
  try {
    const response = yield call(apiOutlets.outlets);
    yield put(actGratuity.setOutlets(response.data));

    const resProfile = yield call(apiProfile.getProfile);
    clevertapLibraryGratuity.libraryGratuityStart({
      currOutlet: resProfile.data.outlet_id[0],
    });

    yield call(fillSearchFormFromProfile, resProfile.data);

    const resGratuities = yield call(apiGratuity.getGratuities, { page: 1 });
    const gratuities = resGratuities.data.results;
    yield put(actGratuity.setGratuities(gratuities));
    yield put(actGratuity.setTotalPage(resGratuities.data.total_pages));
    yield put(actGratuity.setCurrentPage(1));
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* gratuitiesRequest(action) {
  const {
    payload: { params, previousGratuities },
  } = action;
  yield put(act.showProgressBar());

  try {
    const response = yield call(apiGratuity.getGratuities, params);
    const gratuities = previousGratuities.concat(response.data.results);
    yield put(actGratuity.setGratuities(gratuities));
    yield put(actGratuity.setTotalPage(response.data.total_pages));
    yield put(actGratuity.setCurrentPage(params.page));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* onChangeOutletIds(action) {
  yield put(actGratuity.setGratuities([]));
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { outletIds },
  } = action;
  const previousOutlet = yield select(getSelectedOutlet);
  clevertapLibraryGratuity.libraryGratuityChangeOutlet({
    previousOutlet,
    currOutlet: outletIds,
  });
  try {
    yield put(actGratuity.setGratuityDetail(null));
    yield call(closeRightColumn);
    yield call(fillForm, { id: null, amount: null, quantity: null });
    yield put(act.showProgressBar());
    yield call(apiOutlets.patchLogin, { id: outletIds });
    yield put(setSelectedOutletIds(outletIds));
    yield put(change('search', 'outletIds', outletIds));
    const res = yield call(apiGratuity.getGratuities, { page: 1 });
    yield put(actGratuity.setGratuities(res.data.results));
    yield put(actGratuity.setTotalPage(res.data.total_pages));
    yield put(actGratuity.setCurrentPage(1));
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* clickGratuityRow(request) {
  const {
    payload: { gratuity },
  } = request;
  try {
    yield put(act.showProgressBar());

    const res = yield call(apiGratuity.getGratutityById, gratuity.id);
    yield put(actGratuity.setGratuityDetail(res.data));
    yield call(fillForm, res.data);
    yield call(openRightColumn);
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* submitFormCreate(request) {
  const {
    payload: { data, previousGratuities },
  } = request;
  yield put(act.showProgressBar());
  yield put(actGratuity.isSubmittingForm(true));
  try {
    const response = yield call(apiGratuity.postGratuity, data);
    // set to reducers
    const gratuity = response.data;
    const gratuities = [gratuity];
    previousGratuities.forEach(g => gratuities.push(g));

    yield put(
      actNotif.success(
        'Gratuity successfully created.',
        yield getCloneOutletNotification()
      )
    );
    yield put(actGratuity.setGratuities(gratuities));
    yield put(actGratuity.setGratuityDetail(gratuity));
    yield call(fillForm, gratuity);
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actGratuity.isSubmittingForm(false));
  }
}

export function* submitFormCreateAllOutlet(request) {
  const {
    payload: { data, previousGratuities },
  } = request;
  yield put(act.showProgressBar());
  yield put(actGratuity.isSubmittingForm(true));
  try {
    const response = yield call(apiGratuity.postCreateAllOutlet, data);
    // set to reducers
    const gratuity = response.data;
    const gratuities = [gratuity];
    previousGratuities.forEach(g => gratuities.push(g));

    yield put(
      actNotif.success(
        'Gratuity successfully created.',
        yield getCloneOutletNotification()
      )
    );
    yield put(actGratuity.setGratuities(gratuities));
    yield put(actGratuity.setGratuityDetail(gratuity));
    yield call(fillForm, gratuity);
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actGratuity.isSubmittingForm(false));
  }
}

export function* submitFormUpdate(request) {
  const {
    payload: { data, gratuityId, previousGratuities },
  } = request;
  yield put(act.showProgressBar());
  yield put(actGratuity.isSubmittingForm(true));
  try {
    const response = yield call(apiGratuity.putGratuity, gratuityId, data);
    // set to reducers
    const gratuity = response.data;
    const gratuities = [];
    previousGratuities.forEach(g => {
      if (g.id === gratuityId) {
        gratuities.push(gratuity);
      } else {
        gratuities.push(g);
      }
    });

    yield put(
      actNotif.success(
        'Gratuity successfully updated.',
        yield getCloneOutletNotification()
      )
    );
    yield put(actGratuity.setGratuities(gratuities));
    yield put(actGratuity.setGratuityDetail(gratuity));
    yield call(fillForm, gratuity);
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actGratuity.isSubmittingForm(false));
  }
}

export function* deleteGratuity(request) {
  const {
    payload: { gratuityId, previousGratuities },
  } = request;
  yield put(act.showProgressBar());
  _.forEach(previousGratuities, gratuity => {
    if (gratuityId === gratuity.id)
      clevertapLibraryGratuity.libraryGratuityDelete({ gratuity });
  });
  try {
    yield call(apiGratuity.deleteGratuity, gratuityId, previousGratuities.name);
    // set to reducers

    const gratuities = [];
    previousGratuities.forEach(g => {
      if (g.id !== gratuityId) {
        gratuities.push(g);
      }
    });
    yield put(actGratuity.setGratuities(gratuities));
    yield put(actGratuity.setGratuityDetail(null));
    yield put(actGratuity.setDeletedGratuity(null));
    yield put(actGratuity.hideDeleteGratuityModal());
    yield call(closeRightColumn);
    yield call(fillForm, { id: null, amount: null, quantity: null });
    yield put(
      actNotif.success(
        'Gratuity successfully deleted.',
        yield getCloneOutletNotification()
      )
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* clickCancel() {
  yield put(actGratuity.setGratuityDetail(null));
  yield call(fillForm, { id: null, amount: null, name: null });
  yield call(closeRightColumn);
}

export function* clickCreateGratuity() {
  yield put(actGratuity.setGratuityDetail(null));
  yield call(fillForm, { id: null, amount: null, name: null });
  yield call(openRightColumn);
}

export function* askDeleteGratuity(request) {
  const {
    payload: { deletedGratuity },
  } = request;
  yield put(actGratuity.setDeletedGratuity(deletedGratuity));
  yield put(actGratuity.showDeleteGratuityModal());
}

export function* cancelDeleteGratuity() {
  yield put(actGratuity.setDeletedGratuity(null));
  yield put(actGratuity.hideDeleteGratuityModal());
}

export default function* saga() {
  yield takeLatest(LIBRARY_GRATUITY_PAGE_REQUEST, pageRequest);
  yield takeLatest(LIBRARY_GRATUITY_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);
  yield takeEvery(LIBRARY_GRATUITY_GRATUITIES_REQUEST, gratuitiesRequest);
  yield takeLatest(LIBRARY_GRATUITY_ON_CLICK_CANCEL, clickCancel);
  yield takeLatest(LIBRARY_GRATUITY_ON_CLICK_ROW, clickGratuityRow);
  yield takeLatest(LIBRARY_GRATUITY_SUBMIT_FORM_CREATE, submitFormCreate);
  yield takeLatest(
    LIBRARY_GRATUITY_ON_CLICK_CREATE_GRATUITY,
    clickCreateGratuity
  );
  yield takeLatest(LIBRARY_GRATUITY_DELETE_GRATUITY, deleteGratuity);
  yield takeLatest(LIBRARY_GRATUITY_ASK_DELETE_GRATUITY, askDeleteGratuity);
  yield takeLatest(LIBRARY_GRATUITY_SUBMIT_FORM_UPDATE, submitFormUpdate);
  yield takeLatest(
    LIBRARY_GRATUITY_CANCEL_DELETE_GRATUITY,
    cancelDeleteGratuity
  );
  yield takeLatest(
    LIBRARY_GRATUITY_SUBMIT_FORM_CREATE_ALL_OUTLET,
    submitFormCreateAllOutlet
  );
}
